import BidMatchSettings from './BidMatchSettings';

export default BidMatchSettings;



// WEBPACK FOOTER //
// ./src/components/BidMatchSettings/index.jsx